import BaseProxy from './Proxy';

export default class PersistentConfirmationsProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/persistentconfirmations', parameters);
  }

  partnerInfo(partnerNumber) {
    return this.submit('get', `${this.endpoint}/contentPartnerDetails/${partnerNumber}`);
  }

  modify(id, toBeDeleted) {
    return this.submit('post', `${this.endpoint}/modify`, { id, toBeDeleted });
  }
}
